import { SVGProps } from 'react';

interface CalculatorIconProps extends SVGProps<SVGSVGElement> {
  size?: number;
}

/**
 * Calculator Icon
 *
 * Represents the built-in dive calculator feature.
 * Calculator design with buttons.
 */
export function CalculatorIcon({ size = 24, ...props }: CalculatorIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="4"
        y="2"
        width="16"
        height="20"
        rx="2"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <rect
        x="6"
        y="4"
        width="12"
        height="4"
        rx="1"
        fill="currentColor"
        opacity="0.3"
      />
      <rect x="6" y="4" width="12" height="4" rx="1" stroke="currentColor" strokeWidth="1" />
      <circle cx="8" cy="12" r="1.2" fill="currentColor" />
      <circle cx="12" cy="12" r="1.2" fill="currentColor" />
      <circle cx="16" cy="12" r="1.2" fill="currentColor" />
      <circle cx="8" cy="16" r="1.2" fill="currentColor" />
      <circle cx="12" cy="16" r="1.2" fill="currentColor" />
      <circle cx="16" cy="16" r="1.2" fill="currentColor" />
      <rect x="7" cy="19" width="10" height="2" rx="0.5" fill="currentColor" />
    </svg>
  );
}
